import React from 'react';
import { Link, linkToRecord } from 'react-admin';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  link: {
    cursor: 'pointer',
    '& *': {
      cursor: 'pointer'
    }
  }
};

const LinkField = props => {
  const {
    record = {},
    source,
    basePath,
    idSource,
    classes,
    render,
    linkType = 'edit',
    resource,
    ...rest
  } = props;

  return (
    <Link
      to={`${linkToRecord(basePath, record[idSource], linkType)}`}
      className={classes.link}
      id={render ? render(record) : record[source]}
      {...rest}
    >
      {render ? render(record) : record[source]}
    </Link>
  );
};

LinkField.propTypes = {
  source: PropTypes.string,
  record: PropTypes.object.isRequired,
  idSource: PropTypes.string,
  render: PropTypes.func,
  linkType: PropTypes.string
};

LinkField.defaultProps = {
  source: 'id',
  idSource: 'id'
};

export default withStyles(styles)(LinkField);
